import { TableTypes } from '@/constant';
import { memo, useCallback } from 'react';

import { SelectForeignBusinessModal, TableWithActions } from '..';
import { useLogic } from './logic';
import { IProps } from './type';

const ContractedForeignBusinessComponent = (props: IProps) => {
	const {
		columns,
		rowSelection,
		canEdit,
		reduxParams,
		total,
		fetchData,
		handlePageChange,
		handlePageSizeChange,
	} = useLogic(props);
	const ActionsRightComponent = useCallback(() => {
		return (
			<SelectForeignBusinessModal allowSelectMultiple fetchData={fetchData} />
		);
	}, [fetchData]);
	return (
		<div className="bg-white">
			<TableWithActions
				columns={columns}
				titleInDetail="계약된 해외 사업체"
				actionsRight={<ActionsRightComponent />}
				actionsTop
				actionHidden={!canEdit}
				rowKey="id"
				tableType={TableTypes.CONTRACTED_FOREIGN_BUSINESS}
				editable={false}
				rowSelection={canEdit ? { ...rowSelection } : undefined}
				onDeleteSuccessCallback={fetchData}
				onPageChange={handlePageChange}
				onPageSizeChange={handlePageSizeChange}
				pagination={{
					defaultPageSize: reduxParams?.pageSize,
					current: reduxParams?.page,
					pageSize: reduxParams?.pageSize,
					total,
				}}
			/>
		</div>
	);
};

export const ContractedForeignBusiness = memo(
	ContractedForeignBusinessComponent
);
